import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { addCartItem } from "../../store/cart";
import { useGlobalStore } from "../../store/global";
import { useModalStore } from "../../store/modal";
import { useVariantsStore } from "../../store/variants";
import { computePriceWithDiscount, formatPrice, getTemplateData, roundPrice, } from "../../utils";
import AddToCart from "../cart/add-to-cart";
import AddToCartVariant from "../cart/add-to-cart-variant";
import { addToFavorite } from "./add-to-favorite";
import ProductStock from "./detail/product-stock";
import { isSellable } from "./utils";
import { useCategoryStore } from "@/store/category";
export function ProductCard({ product }) {
    const urls = useGlobalStore((state) => state.config.urls);
    const isAuth = useGlobalStore((state) => state.config.isAuth);
    const texts = useGlobalStore((state) => state.config.texts);
    const settings = useGlobalStore((state) => state.config.template_settings);
    const api = useGlobalStore((state) => state.config.api);
    const open = useModalStore((state) => state.open);
    const set = useVariantsStore((state) => state.set);
    const filter = useCategoryStore((state) => state.filter);
    const selectedValues = useVariantsStore((state) => state.selectedValues);
    const [isFav, setIsFav] = React.useState(product.is_favorite);
    const sellable = isSellable(product, 1);
    const filterVariants = React.useMemo(() => {
        const filterVariants = [];
        filter.attributes.forEach(attribute => {
            const filterVariant = product.variants.find(variant => {
                return variant.values.find(value => {
                    return value.attribute_id === attribute.id && attribute.values.includes(value.id);
                });
            });
            if (filterVariant) {
                filterVariants.push(filterVariant);
            }
        });
        return filterVariants;
    }, [filter]);
    const image = settings.category.swap_variant_image.enabled && filterVariants.length > 0
        ? filterVariants[0].images[0]
        : product.image;
    const handleAddToCart = async () => {
        if (sellable) {
            if (product.variants.length > 0) {
                set({
                    variants: product.variants,
                    attributes: product.attributes,
                });
                open({
                    title: texts["text227"],
                    content: _jsx(AddToCartVariant, { ...product }),
                });
            }
            else {
                await addCartItem(api.cart.add, product.id, 1);
                open({
                    title: texts["text227"],
                    content: _jsx(AddToCart, { ...product }),
                });
            }
        }
    };
    async function handleAddToFavorites() {
        addToFavorite(isAuth, urls.profile.show, api.product.add_to_favorite, product.id, (result) => setIsFav(result));
    }
    function handleVideoClick(url) {
        open({
            title: product.title,
            content: (_jsx("div", { id: "product-card-video", children: _jsx("iframe", { src: url }) })),
        });
    }
    function getProductUrl() {
        const parameters = selectedValues.map(value => {
            return `attrs[${value.attribute.id}]=${value.value.id}`;
        });
        return `${product.url}${parameters.length ? '?' + parameters.join("&") : ''}`;
    }
    return (_jsxs("div", { className: "product-card", children: [_jsxs("div", { className: "product-card-top", children: [_jsxs("div", { className: "product-card-header", children: [_jsx("a", { href: getProductUrl(), children: _jsx("img", { alt: image?.alt ?? "image", src: image.url, "data-loaded": "true" }) }), _jsx("div", { className: "product-card-badges", children: product.badges?.map((badge, i) => (_jsx("span", { className: "badge", style: { backgroundColor: badge.color }, children: badge.name }, `badge-${i}`))) }), settings.product_teaser.favorite_icon.enabled && (_jsx("svg", { onClick: handleAddToFavorites, className: "product-card-add-to-favorites", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 16 16", children: _jsx("path", { className: "b", d: isFav
                                        ? "M29845.3,832.747a6.4,6.4,0,0,0-.6-.408,22.31,22.31,0,0,1-1.9-1.453,20.407,20.407,0,0,1-2.1-2.149,6.937,6.937,0,0,1-1.3-2.842,3.708,3.708,0,0,1,.7-3.378,3.834,3.834,0,0,1,3.1-1.412,4.959,4.959,0,0,1,3,1.091c.1.019.1.038.1.058,0-.02.1-.039.1-.058a5.224,5.224,0,0,1,3-1.091,3.978,3.978,0,0,1,3.9,4.847,7.214,7.214,0,0,1-1.5,2.781,13.628,13.628,0,0,1-2,2.137,23.178,23.178,0,0,1-1.9,1.456,5.214,5.214,0,0,1-.6.409,2.285,2.285,0,0,1-1,.3A2.262,2.262,0,0,1,29845.3,832.747Z"
                                        : "M29845.6,832.9l.7-1.211.8,1.2A1.465,1.465,0,0,1,29845.6,832.9Zm-.3-9.674a4.026,4.026,0,0,0-2.1-.711,2.439,2.439,0,0,0-2.5,3.109c.6,3.08,5.6,6.065,5.6,6.065l-.7,1.211v-.013c0-.008-.1-.018-.1-.031s-.1-.063-.2-.111a3.686,3.686,0,0,0-.6-.408,22.31,22.31,0,0,1-1.9-1.453,20.407,20.407,0,0,1-2.1-2.149,6.937,6.937,0,0,1-1.3-2.842,3.708,3.708,0,0,1,.7-3.378,3.834,3.834,0,0,1,3.1-1.412,4.959,4.959,0,0,1,3,1.091c.1.019.1.038.1.058,0-.02.1-.039.1-.058a5.224,5.224,0,0,1,3-1.091,3.978,3.978,0,0,1,3.9,4.847,7.214,7.214,0,0,1-1.5,2.781,13.628,13.628,0,0,1-2,2.137,23.178,23.178,0,0,1-1.9,1.456c-.2.175-.5.313-.6.409-.1.048-.1.086-.2.112v.044l-.8-1.2s4.9-3.009,5.6-6.065a2.553,2.553,0,0,0-2.5-3.109,3.409,3.409,0,0,0-2,.711,4.969,4.969,0,0,0-1.1.927A6.213,6.213,0,0,0,29845.3,823.228Z", transform: "translate(-29838.268 -819.105)" }) }))] }), _jsx("a", { href: product.url, children: _jsx("h3", { className: "product-card-title", children: product.title }) }), settings.product_teaser.short_description.enabled && (_jsx("div", { className: "product-card-description", dangerouslySetInnerHTML: {
                            __html: product.short_description,
                        } }))] }), _jsxs("div", { className: "product-card-bottom", children: [_jsxs("div", { className: "product-card-stock-video", children: [settings.product_teaser.availability.enabled && (_jsx(ProductStock, { ...product, defaultValue: product.quantity })), product.video && (_jsxs("button", { className: "product-card-video", onClick: () => handleVideoClick(product.video ?? ""), children: [_jsx("i", { className: "fa-brands fa-youtube" }), _jsx("span", { children: "Video" })] }))] }), _jsx(Price, { product: product, filterVariants: filterVariants }), settings.product_teaser.cart_button.enabled && (_jsxs("button", { className: "primary product-card-button", onClick: handleAddToCart, disabled: !sellable, children: [settings.product_teaser.cart_icon && (_jsx("i", { className: "fa-solid fa-cart-shopping mr-2" })), texts["text210"]] })), settings.product_teaser.detail_button.enabled && (_jsx("button", { className: "primary product-card-button", onClick: () => (window.location.href = product.url), children: texts["text533"] }))] })] }));
}
function Price({ product, filterVariants }) {
    const settings = useGlobalStore((state) => state.config.template_settings);
    const currency = useGlobalStore((state) => state.config.currency);
    const customer_discount = useGlobalStore((state) => state.config.customer?.discount ?? 0);
    let discount = product.discount || 0;
    if (customer_discount > 0) {
        discount = discount > 0 ? discount * (customer_discount / 100) : customer_discount;
    }
    let priceWithVat = roundPrice(product.price_with_vat, currency);
    let priceWithVatAfterDiscount = roundPrice(computePriceWithDiscount(product.price_with_vat, discount), currency);
    if (settings.category.swap_variant_price.enabled && filterVariants.length > 0) {
        const variant = filterVariants[0];
        priceWithVat = roundPrice(variant.price_with_vat, currency);
        priceWithVatAfterDiscount = roundPrice(computePriceWithDiscount(variant.price_with_vat, discount), currency);
    }
    const unit = settings.product_detail.show_unit.enabled
        ? ` / ${product.unit}`
        : "";
    return (_jsxs("div", { className: "product-card-price", children: [_jsx("div", { className: "d-flex", children: discount > 0 && (_jsx("span", { className: "badge", children: `-${discount}%` })) }), _jsxs("div", { className: "d-flex align-items-center", children: [_jsx("h3", { children: `${formatPrice(priceWithVatAfterDiscount, currency)}${unit}` }), discount > 0 && (_jsx("del", { className: "ml-2", children: `${formatPrice(priceWithVat, currency)}${unit}` }))] })] }));
}
export default function ProductCardTemplate({ templateData }) {
    const product = getTemplateData("data-product", templateData);
    const isInited = useGlobalStore((state) => state.isInited);
    if (!isInited)
        return null;
    return _jsx(ProductCard, { product: product });
}
